<template>
  <form>
    <string-form-field
      :label="$t('statusArrow.fields.label')"
      required
      :value="value.label"
      :disabled="disabled"
      :error="findError('label')"
      @input="propertyChange('label', $event)"
    />

    <!--
    <b-button
      v-if="!disabled && !['INITIAL', 'SUCCESS', 'FAILURE'].includes(value.type)"
      block
      variant="remove"
      @click.prevent="$emit('remove')">
      {{ $t('common.remove') }}
    </b-button>
    -->
  </form>
</template>
<script>
import EditorMixin from "vue-template/common/mixins/EditorMixin";

export default {
  mixins: [EditorMixin]
};
</script>
